import React from "react";
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteButtonCell = (deleteFn) => (props) => {
    const { dataItem } = props;

    return <><td className={"command-cell"}>
        <DeleteIcon onClick={() => {
            deleteFn(dataItem);
        }} />
    </td></>
};

export default DeleteButtonCell;
